import { useContext, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import { AppText, Button, CustomContainer, GridContainer } from "src/style"
import {ReactComponent as Smiley} from 'src/assets/img/sad-smiley.svg'
import { AppCenterPopupPlusD2, Portal, RadioSelection, TitleWithBackIconD2 } from "src/component"

export const AccountDeletionReasonD2: React.FC<any> = ({next, back, close}) => {
    const {API} = useContext(ApiContext)
    const {user, setUserProperty} = useContext(UserContext)
    const {notifier} = useContext(VisibilityContext)
    const [reason, setReason] = useState('')
    
    async function handleProceed() {
        if (!reason) return notifier.show('Kindly select a reason')
        
        await setUserProperty('acctDeletionData', {...user.acctDeletionData, reason})
        if (reason != 'Others') {
            const response = await API.sendProfileDeactivationOtp()
            if (response) next('otp-validation')
        }
        else next('other-reasons')
    }

    return (
        <Portal>
            <AppCenterPopupPlusD2
                title='We hate to see you go!' 
                height='59' overflow='hidden'
                contentHeight='59' zIndex='6'
                maxHeight='85'
                close={close} 
                back={back}
            >
                <TitleWithBackIconD2 title='We hate to see you go!' backMethod={back}/>
                
                <CustomContainer>
                    <GridContainer>
                        <Smiley />
                    </GridContainer>
                    <AppText align="center" topMargin="1" bottomMargin="2">
                        Please tell us why you are deleting your account to help us serve you better.
                    </AppText>

                    <RadioSelection 
                        options={[
                            'I am dissatisfied with the app', 
                            'I am relocating and will no longer need access to the app', 
                            'I am concerned about my privacy and do not want my data to be collected, stored, or shared by the app',
                            'Others'
                        ]}
                        width={'100'}
                        noDefault
                        hasStartRingPosition
                        value={reason}
                        output={(val: string) => setReason(val)}
                    />
                    
                    <CustomContainer topMargin="2">
                        <Button 
                            width='100' sizeUnit="%" height='4.4' 
                            borderColor='#0D968F' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4'
                            onClick={() => handleProceed()}
                        >
                            Proceed
                        </Button>
                    </CustomContainer>
                </CustomContainer>
            </AppCenterPopupPlusD2>
        </Portal>
    )
}
